import React from "react";
import styled from "styled-components";
import Image from "next/image";
import ClockIcon from "../../../../../public/images/clock.svg";
import CocktailBrownIcon from "../../../../../public/images/cocktail_brown.svg";
import LocationMaincolorIcon from "../../../../../public/images/location-maincolor.svg";
import CutleryIcon from "../../../../../public/images/cutlery.svg";
import GroupIcon from "../../../../../public/images/group.svg";
import WorldIcon from "../../../../../public/images/world.svg";
import LibraryIcon from "../../../../../public/images/library.svg";
import SmileIcon from "../../../../../public/images/smile.svg";
import {getColor} from "@/styles/ThemeConfig";
import {HeroCarousel} from "@/components/other/HeroCarousel";
import StarIcon from "../../../../../public/images/star_gold.svg";
import CheckIcon from "../../../../../public/images/check_green.svg";
import {VariantBHeroCarousel} from "@/components/other/VariantBHeroCarousel";
import VariantBLogosSection from "@/components/tour/sections/variantB/VariantBLogosSection";
import VariantBBreadcrumbs from "@/components/tour/sections/variantB/VariantBBreadcrumbs";


const Section = styled.section`
  position: relative;
  width: 100%;
`;


const Overlay = styled.div`
    z-index: 2;
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
`;

const Content = styled.div`
  position: relative;
  z-index: 11;
  padding: 10px 24px;
  text-align: left;
`;

const ReviewBar = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  opacity: 0.95;
`;

const Stars = styled.span`
  color: #F7B600;
  letter-spacing: 2px;
    padding-top: 5px;
`;

const Title = styled.h1`
  margin: 0 0 8px;
  font-size: 30px;
  line-height: 1.1;
  font-weight: 700;
  text-transform: uppercase;
`;

const Description = styled.p`
  max-width: 820px;
  margin: 0 auto 20px;
  font-size: 16px;
  line-height: 1.6;
  opacity: 0.95;
    font-family: 'Poppins';
`;


const CTA = styled.a`
  margin: 12px 0 24px;
  background: #FF5A5F;
  color: #fff;
  border: 0;
  padding: 14px 22px;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
    text-decoration: none;
    background: #FF5A5F;
    border-radius: 7.10448px;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 15.9851px 35.5224px;

    padding-top: 20px;

    width: 100%;
    height: 67.97px;

    background: #FF5A5F;
    border-radius: 7.10448px;

    flex: none;
    order: 3;
    flex-grow: 0;

    align-self: center;
    justify-self: center;
`;

const Badges = styled.ul`
  list-style: none;
  padding: 0;
  margin: 18px 0 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  justify-content: center;
  font-size: 14px;
  opacity: 0.95;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    align-content: center;
    padding: 0px;
    gap: 0px 14px;

    background-color: #EBEBE8;

    width: 100%;
    height: 102px;

    border-radius: 10px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 1;

`;

const InfoItem = styled.div`
    color: ${getColor('green')};
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
    font-size: 14px;
    font-family: 'Inter';
`;

const VideoWrapper = styled.div`

`;

// See the note on DesktopWrapper in VariantBHeroSection: only one of the two
// heroes is rendered, so this one must not be CSS-hidden either.
const MobileWrapper = styled.div``;

const FeatureList = styled.div`
  list-style: none;
  padding: 0;
  margin: 12px auto 8px;
  max-width: 640px;
  text-align: left;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0;
  font-size: 16px;
  opacity: 0.95;
    font-family: 'Inter';
    img{
        height: 20px!important;
        width: auto;
        padding-top: 5px;
    }
`;


export default function VariantBHeroSectionMobile({
    cityName,
    ctaButtonData,

    reviewOverlayData,
    heroReviewsText,
    heroMedia,
    title,
    dropdownData,
    dropdownBackButtonText,
    dropdownBackButtonLink,
    heroTitle,
    duration,
    location,
    numOfStops,
    numOfPeople,
    type,
    funFact,
    language,
    wineTastings,
    heroDescription,
    featureList,
    pressLogos,
    breadcrumbds,
}) {
    const resolvedFeatureList = featureList ?? [
        {
            icon: CheckIcon,
            text: "Skip the overpriced tourist traps"
        },
        {
            icon: CheckIcon,
            text: "Uncover the city's history and culture"
        },
        {
            icon: CheckIcon,
            text: "Exclusive food tours in 140+ cities worldwide"
        }
    ];

    const isHeroVideo = [
        'video/mp4',     // MP4
        'video/webm',    // WebM
        'video/ogg',     // Ogg
        'video/quicktime', // MOV
        'video/x-msvideo', // AVI
        'video/x-ms-wmv',  // WMV
        'video/x-flv',   // FLV
        'video/mpeg',    // MPEG
        'video/3gpp',    // 3GPP
        'video/3gpp2',   // 3GPP2
        'video/x-matroska', // MKV
        'video/vnd.dlna.mpeg-tts', // DLNA MPEG-TS
        'application/vnd.apple.mpegurl', // HLS (M3U8)
        'video/x-m4v'    // M4V
    ].includes(heroMedia?.[0]?.mime);



  return (
      <MobileWrapper>
          {
              isHeroVideo && (
                  <VideoWrapper>
                      <video
                          key={heroMedia?.[0]?.url}
                          ref={(videoElement) => {
                              if (videoElement) {
                                  setTimeout(() => {
                                      videoElement.play().catch((err) => {
                                          console.error("Video play failed", err);
                                      });
                                  }, 500); // Delay autoplay by 500ms
                              }
                          }}
                          loop
                          muted
                          playsInline
                          preload="metadata"
                          controls={true}
                          poster={'/images/video_default_poster.jpg'}
                          style={{
                              width: "100%",
                              height: "auto",
                          }}
                      >
                          <source src={heroMedia?.[0]?.url} type={heroMedia?.[0]?.mime} />
                          Your browser does not support the video tag.
                      </video>
                  </VideoWrapper>
              )
          }

          {!isHeroVideo && <VariantBHeroCarousel images={heroMedia}/>}

          {/* Desktop shows the breadcrumb under the hero's H2; on mobile it sits right under the hero media. */}
          {breadcrumbds?.length > 0 && (
              <div style={{padding:'12px 24px 0'}}>
                  <VariantBBreadcrumbs items={breadcrumbds} small/>
              </div>
          )}

          <Section>

              <Content>
                  <ReviewBar>
                      <Stars>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                      </Stars>
                      <span style={{fontFamily:'Playfair Display'}}>
            {heroReviewsText ?? reviewOverlayData?.data?.leftText}
          </span>
                  </ReviewBar>

                  <Title>{heroTitle ?? title }</Title>

                  <FeatureList>
                    {resolvedFeatureList.map((feature, index) => (
                        <FeatureItem key={index}>
                            <Image src={feature.iconUrl ? (feature.iconUrl.startsWith('http') ? feature.iconUrl : `${(process.env.NEXT_PUBLIC_API_URL || '').replace(/\/api$/, '')}/uploads/${feature.iconUrl}`) : CheckIcon} alt={`FeatureIcon${index}`} width={20} height={20} />
                            {feature.text}
                        </FeatureItem>
                    ))}
                  </FeatureList>

                  <Description>{`
                    ${heroDescription ?? `Skip the tourist traps and truly discover ${cityName} with our top-rated guided food tour, which takes you to delicious, lesser-known food spots loved by locals`}
                  `}</Description>

                  {ctaButtonData?.item_link && <CTA href={ctaButtonData?.item_link ?? '#'}>{ctaButtonData?.item_title ?? 'Book your Tour'}</CTA>}

                  <Image
                      priority
                      loading={'eager'}
                      src={reviewOverlayData?.leftImageMobile?.url}
                      alt={reviewOverlayData?.leftImageMobile?.alt ?? reviewOverlayData?.leftImageMobile?.name}
                      width="430"
                      height="46"
                      style={{
                          width: '430px',
                          maxWidth: '100%',
                          height: 'auto',
                      }}
                  />
              </Content>
          </Section>

          <div style={{marginBottom:'50px'}}>
              <p style={{padding:'0 20px', fontFamily:'Poppins',color:'#144733'}}>Also recommended by</p>
              <VariantBLogosSection logos={pressLogos} bg="transparent"/>


              <div
                  style={{padding:'0 20px'}}
              >
                  <Badges>
                      {
                          duration && <InfoItem>
                              <Image src={ClockIcon} alt="ClockIcon" width={20} height={20} /> {duration}
                          </InfoItem>
                      }
                      {
                          wineTastings && <InfoItem>
                              <Image src={CocktailBrownIcon} alt="CocktailBrownIcon" width={20} height={20} /> {wineTastings}
                          </InfoItem>

                      }
                      {
                          location &&   <InfoItem>
                              <Image src={LocationMaincolorIcon} alt="LocationMaincolorIcon" width={20} height={20} /> {location}
                          </InfoItem>
                      }
                      {
                          !!parseInt(numOfStops) &&  <InfoItem>
                              <Image src={CutleryIcon} alt="CutleryIcon" width={20} height={20} /> {numOfStops}
                          </InfoItem>
                      }
                      {
                          !!parseInt(numOfPeople) && <InfoItem>
                              <Image src={GroupIcon} alt="GroupIcon" width={20} height={20} /> {numOfPeople}
                          </InfoItem>
                      }
                      {
                          language && <InfoItem>
                              <Image src={WorldIcon} alt="WorldIcon" width={20} height={20} /> {language}
                          </InfoItem>
                      }
                      {/*{*/}
                      {/*    type &&  <InfoItem>*/}
                      {/*        <Image src={LibraryIcon} alt="LibraryIcon" width={20} height={20} /> {type}*/}
                      {/*    </InfoItem>*/}
                      {/*}*/}
                      {/*{*/}
                      {/*    funFact && <InfoItem>*/}
                      {/*        <Image src={SmileIcon} alt="SmileIcon" width={20} height={20} /> {funFact}*/}
                      {/*    </InfoItem>*/}
                      {/*}*/}
                  </Badges>
              </div>
          </div>
      </MobileWrapper>
  );
}


